import Vue from 'vue'
import { PostAttendance } from '@src/services/attendance'
import { getSavedState } from '@src/utils/localStorage'

export const state = {
    studentsList: [],
}

export const getters = {}

export const mutations = {
    SET_STUDENTS(state, newList) {
        state.studentsList = newList
    },
    SET_ATTENDANCE(state, student) {
        state.studentsList[student.indexStudent].attendance = student.attendance
    },
    UPDATE_LIST(state, newList) {
        Vue.set(state, 'studentsList', [...newList])
    },
    RESET_ATTENDANCE(state) {
        state.studentsList.forEach((student) => {
            student.attendance = ''
        })
    },
    DELETE_STUDENT(state, student) {
        state.studentsList = state.studentsList.filter(
            ({ publicId }) => publicId !== student
        )
    },
}

export const actions = {
    setAttendanceStudents({ commit }, students) {
        commit('SET_STUDENTS', students)
    },
    changeStudentAttendance({ commit, state, dispatch }, student) {
        const { attendance, studentId } = student
        const indexStudent = state.studentsList.findIndex(
            ({ publicId }) => publicId === studentId
        )
        commit('SET_ATTENDANCE', {
            indexStudent,
            attendance,
        })
        dispatch('updateStudentsList')
    },
    updateStudentsList({ commit, state }) {
        commit('UPDATE_LIST', state.studentsList)
    },
    resetAttendances({ commit, state }) {
        commit('RESET_ATTENDANCE')
        commit('UPDATE_LIST', state.studentsList)
    },
    async setAttendance({ _ }, attendance) {
        attendance.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await PostAttendance(attendance)
        return resp
    },
    deleteStudentFromAttendance({ commit }, student) {
        commit('DELETE_STUDENT', student)
    },
}
